import React from "react";
import { AlertCircle } from "lucide-react";
import { PROBLEM_POINTS } from "../data/mock";
import Reveal from "./Reveal";

const ProblemSection = () => {
  return (
    <section className="py-24 md:py-36 bg-neutral-50 relative overflow-hidden">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <Reveal>
          <div className="max-w-3xl">
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-black/10 text-xs uppercase tracking-[0.2em] font-semibold text-neutral-700">
              <AlertCircle size={14} className="text-pink-500" />
              Das Problem
            </span>
            <h2 className="font-display font-extrabold text-4xl md:text-6xl lg:text-7xl tracking-[-0.03em] leading-[1.02] mt-6 text-neutral-950">
              Reichweite allein bringt{" "}
              <span className="bg-gradient-to-r from-pink-500 via-orange-500 to-purple-500 bg-clip-text text-transparent">
                keine Kunden.
              </span>
            </h2>
            <p className="mt-6 text-lg md:text-xl text-neutral-600 leading-relaxed">
              Die meisten Unternehmen posten regelmäßig – und werden trotzdem
              nicht richtig wahrgenommen. Das Problem liegt selten am Content
              selbst. Es liegt am System dahinter.
            </p>
          </div>
        </Reveal>

        <div className="mt-16 grid sm:grid-cols-2 gap-5">
          {PROBLEM_POINTS.map((p, idx) => (
            <Reveal key={idx} delay={idx * 90}>
              <div
                className="group relative p-8 rounded-2xl bg-white border border-black/5 hover:border-pink-200 transition-all duration-300 hover:shadow-[0_20px_50px_-20px_rgba(236,72,153,0.25)] hover:-translate-y-1"
              >
                <div className="flex items-start gap-4">
                  <div className="shrink-0 w-10 h-10 rounded-full bg-neutral-950 text-white flex items-center justify-center font-bold text-sm">
                    0{idx + 1}
                  </div>
                  <div>
                    <h3 className="font-display font-extrabold text-xl tracking-tight text-neutral-950">
                      {p.title}
                    </h3>
                    <p className="mt-2 text-neutral-600 leading-relaxed">
                      {p.text}
                    </p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={200}>
          <div className="mt-16 p-8 md:p-12 rounded-3xl bg-neutral-950 text-white relative overflow-hidden">
            <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full bg-[radial-gradient(circle,rgba(236,72,153,0.35),transparent_70%)]" />
            <div className="relative">
              <p className="font-display font-extrabold text-2xl md:text-4xl tracking-[-0.02em] leading-tight">
                „Die meisten posten.{" "}
                <span className="bg-gradient-to-r from-pink-400 via-orange-400 to-purple-400 bg-clip-text text-transparent">
                  Wir sorgen dafür, dass man euch versteht.&rdquo;
                </span>
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default ProblemSection;
